import {
  SearchControlSortBy,
  searchControlDefaults,
  type SearchControlData,
} from '@/models/insertionsParameters';

const SORTS_BY_ALLOW = new Set(Object.values(SearchControlSortBy));
const SEARCH_CONTROL_DEFAULTS = searchControlDefaults as SearchControlData;

/**
 * Search in the object whether key exists.
 * Alternatively, the default value or an empty array is returned.
 *
 * @param key - key
 * @param queryParams - queryParams
 */
const getQueryParam = (key: string, queryParams: any): any => {
  const params: any = key in queryParams ? queryParams[key] : null;
  return params || SEARCH_CONTROL_DEFAULTS[key];
};

/**
 * Checks if it is a number. Converts string to number.
 *
 * @param value - value
 * @param defaultValue - defaultValue
 */
const assertNumber = (value: string | number | null, defaultValue: number): number => {
  if (value && /^\d+$/.test(value.toString())) {
    const numberValue = Number(value);
    return numberValue > 0 && numberValue < Number.MAX_SAFE_INTEGER ? numberValue : defaultValue;
  }
  return defaultValue;
};

/**
 * Checks if it is an allowable value.
 *
 * @param value - value
 * @param defaultValue - defaultValue
 */
const assertSort = (
  value: SearchControlSortBy | null,
  defaultValue: SearchControlSortBy,
): SearchControlSortBy => {
  return value && SORTS_BY_ALLOW.has(value) ? value : defaultValue;
};

/**
 * This function either parses data from the arguments, or it parses the values from the window.location.
 * In case of illegal or incorrect values the predefined default value is returned.
 *
 * @param queryData - queryData
 */
export default function searchControlQueryDataValidation(
  queryData?: Record<string, unknown>,
): SearchControlData {
  const searchParams = new URLSearchParams(window.location.search);
  const queryParams = !queryData
    ? {
        page: searchParams.get('page'),
        sortBy: searchParams.get('sortBy'),
        feature: searchParams.get('feature'),
      }
    : { ...queryData };

  return {
    page: assertNumber(getQueryParam('page', queryParams), searchControlDefaults.page),
    sortBy: assertSort(getQueryParam('sortBy', queryParams), searchControlDefaults.sortBy),
    feature: getQueryParam('feature', queryParams),
  };
}
